<template>
  <FormModal
    v-if="data"
    title="Add Site Custom Translation"
    method="POST"
    :endpoint="`partners/${partner_id}/sites/${site_id}/custom-translations`"
    :data="data"
    v-bind="$attrs"
    size="wide"
    @success="success"
  >
    <InputGroup label="Language" name="translation_id">
      <Select
        v-model="data.translation_id"
        endpoint="options/translation-locales"
        prepend-icon="language"
        prepend-icon-prefix="fas"
        @change="onTranslationLocaleChange"
      />
    </InputGroup>

    <InputGroup label="Translation Key" name="translation_key_id">
      <Select
        v-model="data.translation_key_id"
        endpoint="options/translation-keys"
        prepend-icon="key"
        prepend-icon-prefix="far"
        @change="onTranslationLocaleChange"
      />
    </InputGroup>

    <InputGroup label="(Default) English Value" name="current_english_value" v-if="currentEnglishValue">
      <pre class="py-3 px-6 text-sm">{{ currentEnglishValue }}</pre>
    </InputGroup>

    <InputGroup label="(Default) Translated Value" name="current_english_value" v-if="localeTranslation">
      <pre class="py-3 px-6 text-sm">{{ localeTranslation }}</pre>
    </InputGroup>

    <InputGroup label="Value" name="value">
      <TextInput
        v-model="data.value"
        textarea
        :rows="3"
        :placeholder="currentEnglishValue || 'Enter your translation here'"
      />
    </InputGroup>
  </FormModal>
</template>

<script>
export default {
  props: {
    partner_id: {
      type: Number,
      required: true
    },
    site_id: {
      type: Number,
      required: true
    }
  },
  async mounted() {
    const response = await this.$api.get(`options/translation-defaults`)
    this.translationDefaults = response.data?.items ?? []
  },
  data: () => ({
    translationCache: {},
    translationDefaults: [],
    localeTranslation: null,
    data: {
      translation_id: null,
      translation_key_id: null,
      value: ""
    }
  }),
  methods: {
    success() {
      this.$notification.success(`Custom translation successfully added.`)
      this.$emit("close")
    },
    async onTranslationLocaleChange() {
      if (!this.data.translation_id || !this.data.translation_key_id || this.data.translation_id === 1) {
        this.localeTranslation = null
        return
      }

      const translationCacheKey = `translation_${this.data.translation_id}_${this.data.translation_key_id}`

      if (this.translationCache[translationCacheKey]) {
        this.localeTranslation = this.translationCache[translationCacheKey]
        return
      }

      const response = await this.$api.post(
        `partners/${this.partner_id}/sites/${this.site_id}/custom-translations/lookup-translation`,
        {
          translation_id: this.data.translation_id,
          translation_key_id: this.data.translation_key_id
        }
      )

      this.localeTranslation = response.data?.value ?? ""

      this.translationCache[translationCacheKey] = this.localeTranslation
    }
  },
  computed: {
    currentEnglishValue() {
      const translationDefault = this.translationDefaults.find(
        translationDefault => translationDefault.id === this.data.translation_key_id
      )
      return translationDefault ? translationDefault.name : null
    }
  }
}
</script>
